export function calcPercentage(value, total) {
  return Math.round((value / total) * 100);
}

export function calcDynamicIncrement(value) {
  return 0.1 + value * 0.01;
}
